/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import iconSet from 'quasar/icon-set/fontawesome-v6-pro.js'

import {LocalStorage,SessionStorage,Loading,Notify,Dialog} from 'quasar'

export default { config: {"loadingBar":{"size":"7px","color":"green"}},iconSet,plugins: {LocalStorage,SessionStorage,Loading,Notify,Dialog} }
